<mat-toolbar class="subtitulo">Colaboradores</mat-toolbar>
<div class="painel-principal" style="padding: 10px;">
    <div class="painel-consultar">
        <form #formConsultar="ngForm">
            <div fxLayout="row" fxLayoutAlign="start center" fxFlexFill>
                <div ngModelGroup="comboFuncionario" fxFlex="95%">
                    <combo-funcionario  
                        [obrigatorio]="false"
                        [selecionado]="funcionario"
                        (valorChange)="onValorChangeFuncionario($event)"
                        [label]="'Selecione um funcionário'"
                        [desabilitado]="campoDesabilitado()">
                    </combo-funcionario>
                </div>

                <div fxFlex="5%" style="padding-left: 5px;">
                    <mat-checkbox color="primary" [disabled]="campoDesabilitado()" [checked]="ativo" (change)="onChangeCheckAtivo($event)">
                        Ativo?
                    </mat-checkbox>
                </div>
            </div>

            <div dir="rtl" class="botoes" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 20px;"
                fxFlexFill>

                <button mat-raised-button fxFlex="20%" (click)="consultar()">
                    CONSULTAR
                </button>

                <button mat-raised-button fxFlex="20%" style="padding-right: 20px" (click)="limpar()" route>
                    LIMPAR
                </button>

            </div>
        </form>

        <table *ngIf="mostrarTabela; else tabelaSemDados" mat-table [dataSource]="dataSource" style="margin-top: 20px">

            <ng-container matColumnDef="nome">
                <th mat-header-cell *matHeaderCellDef style="width: 25%"> Nome </th>
                <td mat-cell *matCellDef="let element"> {{element.pessoasFisica?.nome}} </td>
            </ng-container>

            <ng-container matColumnDef="matricula">
                <th mat-header-cell *matHeaderCellDef> Matrícula </th>
                <td mat-cell *matCellDef="let element"> {{element.matricula}} </td>
            </ng-container>

            <ng-container matColumnDef="dataAdmissao">
                <th mat-header-cell *matHeaderCellDef> Data Admissão  </th>
                <td mat-cell *matCellDef="let element"> {{element.dataAdmissao | dataSimples}} </td>
            </ng-container>

            <ng-container matColumnDef="tipoFuncionario">
                <th mat-header-cell *matHeaderCellDef> Tipo  </th>
                <td mat-cell *matCellDef="let element"> {{tiposFuncionario.getDescricao(element.tipoFuncionario)}} </td>
            </ng-container>

            <ng-container matColumnDef="cargo">
                <th mat-header-cell *matHeaderCellDef> Cargo  </th>
                <td mat-cell *matCellDef="let element"> {{element?.cargo.nome }} </td>
            </ng-container>

            <ng-container matColumnDef="acoes">
                <th mat-header-cell *matHeaderCellDef> Ações </th>
                <td mat-cell *matCellDef="let element">
                    <button *ngIf="perfilAcesso.deleta"  mat-button (click)="deletar(element)">
                        <mat-icon>delete</mat-icon>
                    </button>
                    <button *ngIf="perfilAcesso.consulta" mat-button (click)="atualizar(element)">
                        <mat-icon>search</mat-icon>
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <div [hidden]="!mostrarTabela">
            <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
        </div>
        <ng-template #tabelaSemDados>
            <div fxLayout="row" fxLayoutAlign="center center" style="padding-top: 20px">
                {{msg}}
            </div>
        </ng-template>

        <div fxLayout="row" *ngIf="perfilAcesso.insere" fxLayoutAlign="end center" fxLayoutGap="16px" style="padding-top: 50px">
            <div>
                <button matTooltip="Adicionar novo funcionário" mat-fab color="primary"
                    [routerLink]="['/funcionario/cadastrar']" routerLinkActive="router-link-active">
                    <mat-icon>add</mat-icon>
                </button>
            </div>
        </div>
    </div>
</div>

